<template>
  <q-select
    v-bind="passedProps"
    ref="select"
    v-model="customValue"
    :disable="disable"
    @input-value="onInputValue"
    @keydown="onBackspace"
  />
</template>
<script>
import { cloneDeep, isEqual, omit } from 'lodash';

export default {
  name: 'CustomSelect',

  props: {
    modelValue: {
      type: [String, Array, null],
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      customValue: null,

      inputValue: '',
      inputValueBackup: '',
      isBackspaceDeleted: false,
    };
  },

  computed: {
    passedProps() {
      return omit(this.$attrs, ['modelValue', 'onInput']);
    }, // passedProps()
  },

  watch: {
    customValue: {
      // todo [vue3-migration]: not sure, as this can be a string or an array, added anyway
      deep: true,
      handler(newCustomValue) {
        this.$emit('update:modelValue', newCustomValue);
      },
    },

    modelValue: {
      immediate: true,
      deep: true,
      handler(modelValue) {
        if (!isEqual(modelValue, this.customValue)) {
          this.customValue = cloneDeep(modelValue);
        }
      },
    },

    inputValue(newVal, oldVal) {
      this.inputValueBackup = oldVal;

      if (!newVal && !this.isBackspaceDeleted) {
        this.addSelectItem();
      }
    },
  },

  created() {
    this.customValue = cloneDeep(this.modelValue);
  }, // created()

  methods: {
    onInputValue(val) {
      this.inputValue = val;
      if (!val) {
        return;
      }
      this.$refs.select.hidePopup();
    },

    addSelectItem() {
      if (this.inputValueBackup) {
        this.$refs.select.add(this.inputValueBackup, true);
      }
    }, // onOptionsInputValue()

    onBackspace(event) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.isBackspaceDeleted = true;
        return;
      }

      this.isBackspaceDeleted = false;
    }, // onBackspace()
  },

};
</script>
